import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const ProtectedRoute = ({ children }) => {
	const token = localStorage.getItem('token');
	if (token) {
		const decodedToken = jwtDecode(token);
		const isExpired = decodedToken.exp * 1000 < Date.now();
		if (!isExpired) {
			console.log("token valid")
		} else {
			localStorage.removeItem('token');
		}
		return React.cloneElement(children, { privileges: decodedToken.privileges });
	}
    
	return <Navigate to="/login" replace />;
};

export default ProtectedRoute;
